module.exports = __webpack_public_path__ + "img/audioTranscript.54938bc8.png";